<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <!-- <div class="card">
          <tracker></tracker>
        </div> -->
        <div class="card mt-4 p-3 pt-0">
          <div class="table-responsive">
            <div class="light">
              <div class="filters">
                <div class="filter">
                  <p class="filter-label">Jewelry Type</p>
                  <v-select
                    :deselectFromDropdown="true"
                    v-model="filterBy.jewelryType"
                    :options="['Ring', 'Necklace', 'Bracelet', 'Earring']"
                    :closeOnSelect="true"
                  >
                  </v-select>
                </div>

                <div class="filter">
                  <p class="filter-label">Diamond Origin</p>
                  <v-select
                    :deselectFromDropdown="true"
                    v-model="filterBy.origin"
                    :options="['Natural', 'Lab Grown']"
                    :closeOnSelect="true"
                  >
                  </v-select>
                </div>

                <div class="filter">
                  <p class="filter-label">Start From:</p>
                  <input
                    type="date"
                    @change="updateTimestamp($event, 'starDate')"
                    class="datetime-input"
                    v-model="filterBy.startDate"
                  />
                </div>
                <div class="filter">
                  <p class="filter-label">End At:</p>
                  <input
                    type="date"
                    @change="updateTimestamp($event, 'endDate')"
                    class="datetime-input"
                    v-model="filterBy.endDate"
                  />
                </div>

                <div class="filter filter-btn">
                  <soft-button
                    type="button"
                    color="primary"
                    variant="gradient"
                    class="ms-auto mb-0 js-btn-next"
                    @click="handleFilter"
                  >
                    Filter
                  </soft-button>
                  <soft-button
                    type="button"
                    color="warning"
                    variant="gradient"
                    class="ms-auto mb-0 js-btn-next"
                    @click="clearFilters"
                  >
                    Clear
                  </soft-button>
                </div>
              </div>
            </div>

            <div class="table-wrapper">
              <div v-if="selectedOrders.length" class="selected-amt">
                You selected: {{ selectedOrders.length }} Orders
              </div>
              <table id="order-list" class="table">
                <thead class="thead-light">
                  <tr>
                    <th>
                      <div>
                        <input
                          v-model="handleSelectedAll"
                          type="checkbox"
                          name=""
                          id=""
                        />
                      </div>
                      <div>Controls</div>
                    </th>
                    <th>Date/Time</th>
                    <th>Order #</th>
                    <th>Origin</th>
                    <th>Item Type</th>
                    <th>SKU</th>
                    <th>Store's Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="order in queriedData"
                    :key="order.id"
                    class="table-row"
                  >
                    <td
                      style="padding-left: 33px; padding-right: 33px"
                      class="align-items-center"
                    >
                      <soft-checkbox
                        class="font-weight-light"
                        :id="order.id"
                        :checked="selectedOrder[order.id]"
                        @input="handleSelectedOrder(order)"
                      />
                    </td>

                    <td class="font-weight-bold">
                      <div class="align-items-center">
                        <!-- <soft-checkbox /> -->
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{ format_date_time(order.createdAt) }}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div>
                        <!-- <soft-checkbox /> -->
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{ order.orderNumber }}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div class="align-items-center">
                        <!-- <soft-checkbox /> -->
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{ order.origin }}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div class="align-items-center">
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{ order.jewelryType }}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div class="align-items-center">
                        <!-- <soft-checkbox /> -->
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{ order.sku }}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div>
                        <!-- <soft-checkbox /> -->
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{
                            format_price(order.priceBreakdown.storeTotalCost)
                          }}
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-wrapper">
              <div class="page-dropdown">
                <label for="orders">Per page: &nbsp; </label>
                <select v-model="pagination.perPage" name="orders">
                  <option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </div>

              <pagination
                :value="pagination.currentPage"
                class="pagination-no-border pagination-success"
                :per-page="pagination.perPage"
                :total="total"
                :from="from"
                :to="to"
                @input="handlePagination"
              >
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftCheckbox from "@/components/SoftCheckbox.vue";
import Pagination from "@/components/Pagination.vue";
import SoftInput from "../../../../../components/SoftInput.vue";
import SoftButton from "../../../../../components/SoftButton.vue";

export default {
  components: {
    SoftCheckbox,
    Pagination,
    SoftInput,
    SoftButton,
  },
  props: {
    tableData: {
      type: Array,
      default: [],
    },
  },
  emits: ["handle-selected-order"],
  data() {
    return {
      selectedOrder: {},
      selectedOrders: [],
      searchedData: [],
      handleSelectedAll: false,
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 250, 500, 1000],
        total: 0,
      },
      filterBy: {
        jewelryType: "",
        origin: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data.
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData.slice(this.from, this.to);
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
    },
  },
  watch: {
    handleSelectedAll(toggle) {
      if (toggle) {
        this.queriedData.forEach((order) => {
          if (this.selectedOrder[order.id]) return null;
          this.selectedOrder[order.id] = true;
          this.selectedOrders.push(order);
        });
      } else {
        this.selectedOrders = [];
        this.selectedOrder = {};
      }

      this.$emit("handle-selected-order", this.selectedOrders);
    },
    tableData(docs) {
      if (!docs.length) {
        this.selectedOrders = [];
        this.selectedOrder = {};
        this.handleSelectedAll = false;
      }
    },
  },
  methods: {
    searchForOrder(e) {
      if (!e.target.value) {
        this.tableData = this.order;
      }
      let input = e.target.value.toLowerCase();
      const validateOrder = (order) => {
        if (
          order.orderNumber.toLowerCase().includes(input) ||
          order.sku.toLowerCase().includes(input) ||
          order.purchaseOrderNumber.toLowerCase().includes(input) ||
          order.consumer.email.toLowerCase().includes(input) ||
          `${order.consumer.name} ${order.consumer.lastName}`
            .toLowerCase()
            .includes(input) ||
          // order.storeId.includes(input) ||
          order.client.company.toLowerCase().includes(input)
        ) {
          return true;
        } else return false;
      };
      this.tableData = this.orders.filter((order) => validateOrder(order));
    },
    handleSelectedOrder(order) {
      if (!this.selectedOrder[order.id]) {
        this.selectedOrders.unshift(order);
        this.selectedOrder[order.id] = true;
      } else {
        this.selectedOrders = this.selectedOrders.filter(
          (o) => o.id !== order.id
        );
        delete this.selectedOrder[order.id];
      }

      this.$emit("handle-selected-order", this.selectedOrders);
    },
    async handleFilter() {
      let timeFilter = false;

      if (
        !this.filterBy.jewelryType &&
        !this.filterBy.origin &&
        !this.filterBy.startDate &&
        !this.filterBy.endDate
      ) {
        this.searchedData = this.tableData;
        return false;
      }

      if (this.filterBy.startDate && this.filterBy.endDate) {
        timeFilter = true;
        let startDateObj =
          typeof this.filterBy.startDate == "object"
            ? DateTime.fromJSDate(this.filterBy.startDate)
            : DateTime.fromISO(this.filterBy.startDate);

        let endDateObj =
          typeof this.filterBy.endDate == "object"
            ? DateTime.fromJSDate(this.filterBy.endDate)
            : DateTime.fromISO(this.filterBy.endDate);

        let startDate = startDateObj
          .setZone("America/New_York")
          .startOf("day")
          .toMillis();

        let endDate = endDateObj
          .setZone("America/New_York")
          .endOf("day")
          .toMillis();

        orderQuery = query(
          orderQuery,
          orderBy("createdAt", "desc"),
          startAt(endDate),
          endAt(startDate)
        );
      }

      this.searchedData = this.tableData.filter((item) => {
        const matchJewelryType =
          !this.filterBy.jewelryType ||
          item.jewelryType === this.filterBy.jewelryType;
        const matchOrigin =
          !this.filterBy.origin || item.origin === this.filterBy.origin;

        return matchJewelryType && matchOrigin;
      });
    },
    clearFilters() {
      for (const key in this.filterBy) {
        if (key === "jewelryType" || key === "origin") {
          this.filterBy[key] = "";
        } else if (key === "startDate" || key === "endDate") {
          this.filterBy[key] = null;
        } else {
          this.filterBy[key] = "";
        }
      }
      this.searchVal = null;
      this.searchedData = [];
    },
  },
};
</script>

<style></style>
